export default __webpack_public_path__ + "assets/models/2422052f1c6d668842c1fab4c0a59220.glb";